import React, { Component } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Tooltip from 'rc-tooltip';

import DropDownMenu from '../DropDownMenu/DropDownMenu';

import { getDefaultValidAccountId } from './../../authentification/SecurityController';
import { setItemStorage } from '../../../utils/storage';
import LoadingSpinner from '../../layout/LoadingSpinner/LoadingSpinner';
import Modal from './../../layout/Modal/Modal';
import { getItemStorage } from '../../../utils/storage';
import HeadwayWidget from '../Widgets/HeadwayWidget';

import AppContext from '../../../context/app-context';
// Css
import './Navbar.css';

// Load icons
import { ReactComponent as OpenMobileMenuIcon } from './../../../assets/icons/menu_white.svg';

export default class Navbar extends Component {
  static contextType = AppContext;

  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      account_menu: [
        {
          name: 'Account Settings',
          link: '/settings/general',
          icon: 'setting',
        },
        {
          name: 'Billing',
          link: '/settings/billing',
          icon: 'billing',
        },
        {
          name: 'Log out',
          link: '/signout',
          icon: 'logout',
          seperator: true,
        },
      ],
      breadcrumbs_items:
        typeof this.props.breadcrumbs_items !== 'undefined'
          ? this.props.breadcrumbs_items
          : [] /** Example of one element  =>  { name: 'Home', link: '/', isLink : true } */,
      isOpenMenu: false,
      background:
        typeof this.props.background !== 'undefined'
          ? this.props.background
          : 'default',
      currentAccountId: '',
      userAccounts: [],
      goto_homePage: false,
      switchAccounts_loading: false,
      trialPeriodMessage_proceeded: false,
      trialPeriodMessage: '',
      isExpiredSubscription: false,
      hideAccountList:
        typeof this.props.hideAccountList !== 'undefined' &&
        [true, false].includes(this.props.hideAccountList)
          ? this.props.hideAccountList
          : false,
    };

    this.openMenu = this.openMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.handleChange__switchCurrentAccount =
      this.handleChange__switchCurrentAccount.bind(this);
    this.handleChange__openMobileSideBar =
      this.handleChange__openMobileSideBar.bind(this);
  }

  openMenu() {
    if (this._isMounted) {
      this.setState(
        {
          isOpenMenu: true,
        },
        () => {
          document.addEventListener('click', this.closeMenu);
        }
      );
    }
  }

  closeMenu() {
    if (this._isMounted) {
      this.setState({ isOpenMenu: false }, () => {
        document.removeEventListener('click', this.closeMenu);
      });
    }
  }

  async handleChange__switchCurrentAccount(event) {
    this.setState({
      switchAccounts_loading: true,
    });
    //console.log("event.target.value" , event.target.value);
    const selectedAccount = event.target.value;
    if (
      this.state.userAccounts.length > 0 &&
      this.state.userAccounts.findIndex((x) => x.id === selectedAccount) >= 0
    ) {
      const localStorageData = await getItemStorage(
        `${process.env.REACT_APP_AUTH_NAME_STORAGE}`
      );
      const accountId = await getItemStorage(
        `${process.env.REACT_APP_STORAGE__ACCOUNT_KEY}`,
        'string'
      );

      if (localStorageData && localStorageData.token) {
        const { token } = localStorageData;

        // Update the default account in the database
        await axios
          .put(
            `${process.env.REACT_APP_API_URL}accounts/${selectedAccount}/as-default`,
            {},
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`, //'JWT token...'
                'X-Odown-Account': accountId,
              },
            }
          )
          .then((res) => {
            const data = res.data;
            this.setState({
              stripeCustomerId: data.scustomer_id,
            });
          })
          .catch((error) => {});
      }

      // update account id in storage
      setItemStorage(
        `${process.env.REACT_APP_STORAGE__ACCOUNT_KEY}`,
        selectedAccount,
        'string'
      );

      // rediect user to home page
      this.setState({
        goto_homePage: true,
        // switchAccounts_loading : false
      });
    }
  }

  getPlanAccountState() {
    if (
      typeof this.context.accountData !== 'undefined' &&
      this.context.accountData !== null
    ) {
      const accountData = this.context.accountData;
      let message = '';
      let isExpiredSubscription = false;
      if (
        typeof accountData.plan !== 'undefined' &&
        accountData.plan !== null &&
        typeof accountData.plan.is_trial !== 'undefined' &&
        accountData.plan.is_trial === true
      ) {
        // is trial period

        // const diff = moment(accountData.plan.periodEnd).diff(moment() , 'minutes');
        const diff = moment().diff(
          moment(accountData.created_at).add(
            accountData.plan.trial_period,
            'days'
          ),
          'minutes'
        );
        //console.log('accountData.created_at : ' , accountData.created_at);
        //console.log('accountData.plan.trial_period : ' , accountData.plan.trial_period);
        //console.log('diff : ' , diff);
        if (diff < 0) {
          message = `👊 You have ${Math.abs(
            Math.ceil(diff / (60 * 24))
          )} days left in your trial`;
        } else {
          message = '😮 Your trial has expired!';
          isExpiredSubscription = true;
        }
      } else if (
        (typeof accountData.plan !== 'undefined' &&
          accountData.plan !== null &&
          typeof accountData.plan.status !== 'undefined' &&
          accountData.plan.status !== 'active') ||
        accountData.plan === null ||
        Object.keys(accountData.plan).length === 0
      ) {
        //
        message = '😮 Your subscription has expired';
        isExpiredSubscription = true;
      }

      if (this.state.trialPeriodMessage_proceeded === false) {
        this.setState({
          trialPeriodMessage: message,
          trialPeriodMessage_proceeded: true,
          isExpiredSubscription,
        });
      }
    }
  }

  async componentDidMount() {
    this._isMounted = true;

    let stateItems = {};
    //console.log('Navbar > componentDidMount : ' , this.context);
    if (
      typeof this.context.connectedUserData !== 'undefined' &&
      this.context.connectedUserData !== null &&
      typeof this.context.connectedUserData.accounts !== 'undefined' &&
      this.context.connectedUserData.accounts !== null &&
      this.context.connectedUserData.accounts.length > 0
    ) {
      const userAccounts = this.context.connectedUserData.accounts;
      stateItems.userAccounts = userAccounts;
    }

    const targetAccountId = await getDefaultValidAccountId(
      this.context.connectedUserData
    );
    if (typeof targetAccountId !== 'undefined' && targetAccountId !== null) {
      stateItems.currentAccountId = targetAccountId;
    }

    if (Object.keys(stateItems).length > 0) {
      this.setState(stateItems); // update state
    }
  }

  componentDidUpdate() {
    //console.log('this.context : ' , this.context);
    //console.log('this._isMounted : ' , this._isMounted);
    // ? is authentificated
    if (
      this.context !== null &&
      typeof this.context.isAuth !== 'undefined' &&
      this.context.isAuth !== null &&
      this.context.isAuth === true
    ) {
      if (
        typeof this.context.connectedUserData !== 'undefined' &&
        this.context.connectedUserData !== null &&
        typeof this.context.connectedUserData.accounts !== 'undefined' &&
        this.context.connectedUserData.accounts !== null &&
        this.context.connectedUserData.accounts.length > 0
      ) {
        const userAccounts = this.context.connectedUserData.accounts;

        if (this.state.userAccounts.length === 0 && this._isMounted) {
          this.setState({
            userAccounts: userAccounts,
          });
        }
      }

      // Generate the plan period state
      if (this._isMounted) this.getPlanAccountState();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleChange__openMobileSideBar(event) {
    //console.log(this.context);

    this.context.openMobileSidebar();
  }

  render() {
    if (this.state.goto_homePage === true) {
      // this.setState({
      // 	goto_homePage : false
      // })
      return window.location.reload(); //<Redirect to="/" />
      // return <Redirect to="/" />
    }

    // //console.log(this.state.breadcrumbs_items);
    return (
      <React.Fragment>
        <nav className={`navbar navbar-light bg-${this.state.background}`}>
          <div
            className={`sidebar-open`}
            onClick={this.handleChange__openMobileSideBar}
          >
            <OpenMobileMenuIcon />
          </div>
          <div className="container">
            <div className="navbar-breadcrumbs-row">
              {this.state.breadcrumbs_items.map((bItem, index) => {
                return (
                  <div className="navbar-breadcrumbs-row-item" key={index}>
                    {bItem.isLink === true ? (
                      <Link
                        className="active limited-text"
                        to={bItem.link}
                        title={bItem.name}
                      >
                        {bItem.name}
                      </Link>
                    ) : (
                      <div className="d-inline limited-text" title={bItem.name}>
                        {bItem.name}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
            <div className="navbar-notice-wrapper">
              {this.state.trialPeriodMessage && (
                <span className="navbar-text navbar-upgrade-notice">
                  {this.state.trialPeriodMessage}
                  {this.state.isExpiredSubscription === true && (
                    <Link to="/settings/billing"> - Upgrade your plan</Link>
                  )}
                </span>
              )}
            </div>
            <div id="nav-collapse" className="navbar-collapse">
              <ul className="ml-auto nav navbar-nav">
                {/* <span className="navbar-text navbar-changelog" style="min-width: 90px;">
								<a href="#">What's New</a>
								<span id="HW_badge_cont" className="HW_badge_cont HW_visible" style="">
									<span id="HW_badge" className="HW_badge HW_softHidden" data-count-unseen="" style=""></span>
								</span>
							</span> */}
                <span className="navbar-text ">
                  <HeadwayWidget />
                </span>
                <span className="navbar-text navbar-docs">
                  <a href="https://odown.io/docs" target="_blanc">
                    Docs
                  </a>
                </span>
                {this.state.hideAccountList === false && (
                  <Tooltip
                    placement="left"
                    trigger={['hover']}
                    overlay={
                      <span>
                        Available accounts list of which you are the owner or
                        the invited.
                      </span>
                    }
                  >
                    <span className="navbar-select account-list">
                      <form>
                        <div className="field-group">
                          <select
                            className="textField "
                            value={this.state.currentAccountId}
                            onChange={this.handleChange__switchCurrentAccount}
                          >
                            {this.state.userAccounts !== null &&
                            this.state.userAccounts.length > 0 ? (
                              this.state.userAccounts.map((item, index) => {
                                return (
                                  <option value={item.id} key={index}>
                                    {item.name}
                                  </option>
                                );
                              })
                            ) : (
                              <option value="">Loading..</option>
                            )}
                          </select>
                        </div>
                      </form>
                    </span>
                  </Tooltip>
                )}
                <li className="dropdown">
                  <a onClick={this.openMenu}>
                    <span className="avatar-wrapper">
                      <span className="avatar-content"></span>
                    </span>
                  </a>
                  {this.state.isOpenMenu && (
                    <DropDownMenu items={this.state.account_menu} />
                  )}
                </li>
                {/* <span className="navbar-text navbar-docs">
								<a href="https://odown.io/docs" target="_blank">Docs</a></span>
							<li className="nav-item dropdown">
								<a href="#" aria-haspopup="true" aria-expanded="false" className="nav-link dropdown-toggle">
									<img src="https://s.gravatar.com/avatar/8bc307f2beb88309d3f5588894403c2d?s=480&amp;r=pg&amp;d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fpi.png" className="navbar-avatar"></a><div role="menu" className="dropdown-menu dropdown-menu-right"><div className="account-selector dropdown-account dropdown-current-account"><div data-v-14482d06="" className="icon d-flex mr-2"><svg version="1.1" width="18" height="18" viewBox="0 0 16 16" className="octicon octicon-home" aria-hidden="true"><path fill-rule="evenodd" d="M8.156 1.835a.25.25 0 00-.312 0l-5.25 4.2a.25.25 0 00-.094.196v7.019c0 .138.112.25.25.25H5.5V8.25a.75.75 0 01.75-.75h3.5a.75.75 0 01.75.75v5.25h2.75a.25.25 0 00.25-.25V6.23a.25.25 0 00-.094-.195l-5.25-4.2zM6.906.664a1.75 1.75 0 012.187 0l5.25 4.2c.415.332.657.835.657 1.367v7.019A1.75 1.75 0 0113.25 15h-3.5a.75.75 0 01-.75-.75V9H7v5.25a.75.75 0 01-.75.75h-3.5A1.75 1.75 0 011 13.25V6.23c0-.531.242-1.034.657-1.366l5.25-4.2h-.001z"></path></svg></div><div className="d-inline">Com</div></div>
									<div role="separator" className="dropdown-divider"></div>
								<a href="/account/" className="dropdown-item active" aria-disabled="false" role="menuitem"><div data-v-14482d06="" className="icon text-muted d-flex mr-2"><svg version="1.1" width="18" height="18" viewBox="0 0 16 16" className="octicon octicon-gear" aria-hidden="true"><path fill-rule="evenodd" d="M7.429 1.525a6.593 6.593 0 011.142 0c.036.003.108.036.137.146l.289 1.105c.147.56.55.967.997 1.189.174.086.341.183.501.29.417.278.97.423 1.53.27l1.102-.303c.11-.03.175.016.195.046.219.31.41.641.573.989.014.031.022.11-.059.19l-.815.806c-.411.406-.562.957-.53 1.456a4.588 4.588 0 010 .582c-.032.499.119 1.05.53 1.456l.815.806c.08.08.073.159.059.19a6.494 6.494 0 01-.573.99c-.02.029-.086.074-.195.045l-1.103-.303c-.559-.153-1.112-.008-1.529.27-.16.107-.327.204-.5.29-.449.222-.851.628-.998 1.189l-.289 1.105c-.029.11-.101.143-.137.146a6.613 6.613 0 01-1.142 0c-.036-.003-.108-.037-.137-.146l-.289-1.105c-.147-.56-.55-.967-.997-1.189a4.502 4.502 0 01-.501-.29c-.417-.278-.97-.423-1.53-.27l-1.102.303c-.11.03-.175-.016-.195-.046a6.492 6.492 0 01-.573-.989c-.014-.031-.022-.11.059-.19l.815-.806c.411-.406.562-.957.53-1.456a4.587 4.587 0 010-.582c.032-.499-.119-1.05-.53-1.456l-.815-.806c-.08-.08-.073-.159-.059-.19a6.44 6.44 0 01.573-.99c.02-.029.086-.075.195-.045l1.103.303c.559.153 1.112.008 1.529-.27.16-.107.327-.204.5-.29.449-.222.851-.628.998-1.189l.289-1.105c.029-.11.101-.143.137-.146zM8 0c-.236 0-.47.01-.701.03-.743.065-1.29.615-1.458 1.261l-.29 1.106c-.017.066-.078.158-.211.224a5.994 5.994 0 00-.668.386c-.123.082-.233.09-.3.071L3.27 2.776c-.644-.177-1.392.02-1.82.63a7.977 7.977 0 00-.704 1.217c-.315.675-.111 1.422.363 1.891l.815.806c.05.048.098.147.088.294a6.084 6.084 0 000 .772c.01.147-.038.246-.088.294l-.815.806c-.474.469-.678 1.216-.363 1.891.2.428.436.835.704 1.218.428.609 1.176.806 1.82.63l1.103-.303c.066-.019.176-.011.299.071.213.143.436.272.668.386.133.066.194.158.212.224l.289 1.106c.169.646.715 1.196 1.458 1.26a8.094 8.094 0 001.402 0c.743-.064 1.29-.614 1.458-1.26l.29-1.106c.017-.066.078-.158.211-.224a5.98 5.98 0 00.668-.386c.123-.082.233-.09.3-.071l1.102.302c.644.177 1.392-.02 1.82-.63.268-.382.505-.789.704-1.217.315-.675.111-1.422-.364-1.891l-.814-.806c-.05-.048-.098-.147-.088-.294a6.1 6.1 0 000-.772c-.01-.147.039-.246.088-.294l.814-.806c.475-.469.679-1.216.364-1.891a7.992 7.992 0 00-.704-1.218c-.428-.609-1.176-.806-1.82-.63l-1.103.303c-.066.019-.176.011-.299-.071a5.991 5.991 0 00-.668-.386c-.133-.066-.194-.158-.212-.224L10.16 1.29C9.99.645 9.444.095 8.701.031A8.094 8.094 0 008 0zm1.5 8a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM11 8a3 3 0 11-6 0 3 3 0 016 0z"></path></svg></div>Account settings</a>
								<a href="/account/team" className="dropdown-item" aria-disabled="false" role="menuitem"><div data-v-14482d06="" className="icon text-muted d-flex mr-2"><svg version="1.1" width="18" height="18" viewBox="0 0 16 16" className="octicon octicon-people" aria-hidden="true"><path fill-rule="evenodd" d="M5.5 3.5a2 2 0 100 4 2 2 0 000-4zM2 5.5a3.5 3.5 0 115.898 2.549 5.507 5.507 0 013.034 4.084.75.75 0 11-1.482.235 4.001 4.001 0 00-7.9 0 .75.75 0 01-1.482-.236A5.507 5.507 0 013.102 8.05 3.49 3.49 0 012 5.5zM11 4a.75.75 0 100 1.5 1.5 1.5 0 01.666 2.844.75.75 0 00-.416.672v.352a.75.75 0 00.574.73c1.2.289 2.162 1.2 2.522 2.372a.75.75 0 101.434-.44 5.01 5.01 0 00-2.56-3.012A3 3 0 0011 4z"></path></svg></div>Team</a>
								<a href="/account/integrations" className="dropdown-item" aria-disabled="false" role="menuitem"><div data-v-14482d06="" className="icon text-muted d-flex mr-2"><svg version="1.1" width="18" height="18" viewBox="0 0 16 16" className="octicon octicon-rocket" aria-hidden="true"><path fill-rule="evenodd" d="M14.064 0a8.75 8.75 0 00-6.187 2.563l-.459.458c-.314.314-.616.641-.904.979H3.31a1.75 1.75 0 00-1.49.833L.11 7.607a.75.75 0 00.418 1.11l3.102.954c.037.051.079.1.124.145l2.429 2.428c.046.046.094.088.145.125l.954 3.102a.75.75 0 001.11.418l2.774-1.707a1.75 1.75 0 00.833-1.49V9.485c.338-.288.665-.59.979-.904l.458-.459A8.75 8.75 0 0016 1.936V1.75A1.75 1.75 0 0014.25 0h-.186zM10.5 10.625c-.088.06-.177.118-.266.175l-2.35 1.521.548 1.783 1.949-1.2a.25.25 0 00.119-.213v-2.066zM3.678 8.116L5.2 5.766c.058-.09.117-.178.176-.266H3.309a.25.25 0 00-.213.119l-1.2 1.95 1.782.547zm5.26-4.493A7.25 7.25 0 0114.063 1.5h.186a.25.25 0 01.25.25v.186a7.25 7.25 0 01-2.123 5.127l-.459.458a15.21 15.21 0 01-2.499 2.02l-2.317 1.5-2.143-2.143 1.5-2.317a15.25 15.25 0 012.02-2.5l.458-.458h.002zM12 5a1 1 0 11-2 0 1 1 0 012 0zm-8.44 9.56a1.5 1.5 0 10-2.12-2.12c-.734.73-1.047 2.332-1.15 3.003a.23.23 0 00.265.265c.671-.103 2.273-.416 3.005-1.148z"></path></svg></div>Integrations</a>
								<a href="/account/api-keys" className="dropdown-item" aria-disabled="false" role="menuitem"><div data-v-14482d06="" className="icon text-muted d-flex mr-2"><svg version="1.1" width="18" height="18" viewBox="0 0 16 16" className="octicon octicon-key" aria-hidden="true"><path fill-rule="evenodd" d="M6.5 5.5a4 4 0 112.731 3.795.75.75 0 00-.768.18L7.44 10.5H6.25a.75.75 0 00-.75.75v1.19l-.06.06H4.25a.75.75 0 00-.75.75v1.19l-.06.06H1.75a.25.25 0 01-.25-.25v-1.69l5.024-5.023a.75.75 0 00.181-.768A3.995 3.995 0 016.5 5.5zm4-5.5a5.5 5.5 0 00-5.348 6.788L.22 11.72a.75.75 0 00-.22.53v2C0 15.216.784 16 1.75 16h2a.75.75 0 00.53-.22l.5-.5a.75.75 0 00.22-.53V14h.75a.75.75 0 00.53-.22l.5-.5a.75.75 0 00.22-.53V12h.75a.75.75 0 00.53-.22l.932-.932A5.5 5.5 0 1010.5 0zm.5 6a1 1 0 100-2 1 1 0 000 2z"></path></svg></div>API keys</a>
								<a href="/account/billing" className="dropdown-item" aria-disabled="false" role="menuitem"><div data-v-14482d06="" className="icon text-muted d-flex mr-2"><svg version="1.1" width="18" height="18" viewBox="0 0 16 16" className="octicon octicon-credit-card" aria-hidden="true"><path d="M10.75 9a.75.75 0 000 1.5h1.5a.75.75 0 000-1.5h-1.5z"></path><path fill-rule="evenodd" d="M0 3.75C0 2.784.784 2 1.75 2h12.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0114.25 14H1.75A1.75 1.75 0 010 12.25v-8.5zm14.5 0V5h-13V3.75a.25.25 0 01.25-.25h12.5a.25.25 0 01.25.25zm0 2.75h-13v5.75c0 .138.112.25.25.25h12.5a.25.25 0 00.25-.25V6.5z"></path></svg></div>Billing</a><div role="separator" className="dropdown-divider"></div>
								<a aria-disabled="false" href="https://github.com/checkly/product-roadmap#suggest-a-feature" target="_blank" rel="noopener" className="dropdown-item" role="menuitem"><div data-v-14482d06="" className="icon text-muted d-flex mr-2"><svg version="1.1" width="18" height="18" viewBox="0 0 16 16" className="octicon octicon-star" aria-hidden="true"><path fill-rule="evenodd" d="M8 .25a.75.75 0 01.673.418l1.882 3.815 4.21.612a.75.75 0 01.416 1.279l-3.046 2.97.719 4.192a.75.75 0 01-1.088.791L8 12.347l-3.766 1.98a.75.75 0 01-1.088-.79l.72-4.194L.818 6.374a.75.75 0 01.416-1.28l4.21-.611L7.327.668A.75.75 0 018 .25zm0 2.445L6.615 5.5a.75.75 0 01-.564.41l-3.097.45 2.24 2.184a.75.75 0 01.216.664l-.528 3.084 2.769-1.456a.75.75 0 01.698 0l2.77 1.456-.53-3.084a.75.75 0 01.216-.664l2.24-2.183-3.096-.45a.75.75 0 01-.564-.41L8 2.694v.001z"></path></svg></div>Suggest a feature</a>
								<div role="separator" className="dropdown-divider"></div>
									<a aria-disabled="false" href="#" target="_self" className="dropdown-item" role="menuitem">Log out</a>
								</div>
							</li> */}
              </ul>
            </div>
          </div>
        </nav>
        {this.state.switchAccounts_loading === true ? (
          <Modal hasCloseButton={false}>
            <div className="switching-accounts_title">
              <h2>Switching accounts..</h2>
            </div>
            <div className="loading-wrapper">
              <LoadingSpinner />
            </div>
          </Modal>
        ) : (
          ''
        )}
      </React.Fragment>
    );
  }
}
